import { render } from "./TurnstileValidate.vue?vue&type=template&id=9f5acf1e"
import script from "./TurnstileValidate.vue?vue&type=script&lang=js"
export * from "./TurnstileValidate.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__